import {ISubscription} from "@retail-data-factory/rdf-angular-types-api";
import {IParty} from "@retail-data-factory/rdf-angular-types-api";

export interface IMarketplaceState {
  subscriptions: Array<ISubscription>;
  datasourceProviders: Array<IParty>;
  isLoaded: boolean;
}

export const initialMarketplaceState:IMarketplaceState = {
  subscriptions: [],
  datasourceProviders: [],
  isLoaded: false
};




/*

export interface ITopPanelStoreValue {
  name: string;
  value: object;
}


export interface ITopPanelState {
  parametersValues: Array<ITopPanelStoreValue>;
  queryParameters: object;
}
export const initialTopPanelState:ITopPanelState = {
  parametersValues: [],
  queryParameters: undefined

};


 */
